import type { RouteLocation } from 'vue-router'
import { useAuthStore } from '@/stores/AuthStore'

export function authMiddleware(to: RouteLocation, _from: RouteLocation) {
  const authStore = useAuthStore()
  const hasRequiredDeviceType =
    (authStore.device_type &&
      to.meta.device_type?.includes(authStore.device_type)) ||
    (!authStore.device_type && !to.meta.device_type)

  if (!hasRequiredDeviceType) {
    console.error('Device type not allowed on the route: ', to.name)
    return false
  }
  return true
}
